<style lang="stylus">
    .bp-layer
        position relative
        display flex
        justify-content center
        align-items center
        height 32px
        margin-right 16px
        .layer-icon
            floatTool_icon()
            width auto
            height 24px
            margin 0
            .item-icon
                color: var(--svg-color-primary);
            &.active
                background var(--bg-color-box-hover)
                .item-icon
                    color: var(--svg-color-active)

    .bplayer-container
        padding: 15px 8px;
        background: var(--bg-color-tertiary)
        border-bottom-left-radius $ft-boxradius
        border-bottom-right-radius $ft-boxradius
        width 240px
        max-height 385px
        overflow auto
        .add-layers
            height 40px
            display flex
            justify-content space-between
            align-items center
            padding 0 8px
            cursor pointer
            &:hover
                background $ft-hover
            .item-icon
                transform translate(0.5px, 0.5px)
                width 20px
                height 20px
                stroke var(--svg-color-gray-42)
                fill var(--svg-color-gray-42)
            div
                color var(--text-color-black)
                font-weight 700
                cursor pointer
        .all-layers
            border-radius 6px
            &:not(.selected):hover
                background $ft-hover
            &:hover .layers-name .layers-del
                display block
            &:hover .layers-edit
                display inline-block
            &:hover .layers-box .layers-move
                display flex
            .layers-edit
                display none
            .layers-name
                font-weight 700
                color var(--text-color-black)
                padding 12px 14px 8px 14px
                height 36px
                display flex
                justify-content space-between
                align-items center
                input
                    border 1px solid var(--themeColor)
                    border-radius 3px
                    width 80px
                    padding-left 8px
                    outline none
                    &:focus
                        outline none
                        border 1px solid var(--themeColor)
                span
                    display inline-block
                    max-width 156px
                    overflow hidden
                    white-space nowrap
                    text-overflow ellipsis
                .layers-del
                    display none
                    cursor: pointer;
                    .item-icon
                        width 16px
                        height 16px
                        stroke var(--svg-color-gray-75)
                        fill var(--svg-color-gray-75)
                        &:hover
                            stroke var(--themeColor)
                            fill var(--themeColor)
            .layers-box
                display flex
                padding-left 14px
                padding-bottom 12px
                .layers-item
                    position relative
                    margin-right 16px
                    cursor: pointer;
                    display flex
                    align-items center
                    justify-content center
                    svg:focus
                        outline none
                    .Navigation-tips-box
                        display flex
                        align-items center
                        justify-content center
                    .ivu-radio-wrapper
                        margin-right 0
                    .ivu-radio
                        margin-right 0

                .layers-move
                    display none

                .layers-shapeCount
                    flex 1
            .item-icon
                width 16px
                height 16px
                stroke var(--svg-color-gray-42)
                fill var(--svg-color-gray-42)
                &:hover
                    stroke var(--themeColor)
                    fill var(--themeColor)
        .selected
            background-color $ft-active
        .moveLayer
            opacity .3


    .floattrans-enter-active,
    .floattrans-leave-active
        transition opacity .3s
    .floattrans-enter,
    .floattrans-leave-to
        opacity 0
</style>

<template>
    <div class="bp-layer" ref="layerbox">
        <div
            ref="iconDom"
            class="layer-icon"
            :class="{ active: showBox, activeFunc: activeFunc == 'bottomLayer' }"
            v-tippy
            :content="dragTitle"
            @click="expandFunc()"
        >
            <iconSymbol v-if="showBox" class="item-icon" name="bplayerActive"></iconSymbol>
            <iconSymbol v-else class="item-icon" name="bplayer"></iconSymbol>
            <span class="zoom-select" :class="{ 'zoom-select_expanded': showBox }">
                <Icon type="ios-arrow-down"></Icon>
            </span>
        </div>

        <transition name="floattrans">
            <LockBoxForTitle
                v-transfer-dom
                ref="floatDom"
                v-show="showBox"
                :data-transfer="true"
                :name="'bpLayer'"
                :dragTitle="dragTitle"
                :show="showBox"
                @lockModal="lockModal"
                @closeModal="closeModal"
            >
                <div class="bplayer-container" @mousedown.stop>
                    <div class="add-layers" @click="newLayer">
                        <div>{{ $t("Layers.newLayer") }}</div>
                        <iconSymbol class="item-icon" name="addLayer" />
                    </div>
                    <vuedraggable
                        @start="closeLayerContext"
                        @end="dragEnd"
                        dragClass="drag-none"
                        force-fallback="true"
                        class="vuedrag-wrap"
                        v-model="layers"
                        v-bind="{ scroll: true, animation: 150, fallbackTolerance: 0, draggable: '.canDrag' }"
                    >
                        <div
                            @contextmenu="
                                activeThis($event, index);
                                showContext($event, item, index);
                            "
                            ref="layersList"
                            v-for="(item, index) in layers"
                            class="all-layers"
                            @click="activeThis($event, index)"
                            :class="{ selected: selectLayerIndex === index, canDrag: !item.back }"
                            :key="index"
                        >
                            <div class="layers-name">
                                <div style="display: flex; align-items: center; width: 100%">
                                    <span v-if="layerEditState != index" :title="item.name">{{ item.name }}</span>
                                    <input
                                        type="text"
                                        v-if="layerEditState == index"
                                        v-model="layerRename"
                                        maxlength="32"
                                        autofocus="autofocus"
                                        :ref="'layer_' + index"
                                        @blur="changeLayerName(index, item)"
                                        @keypress.enter="changeLayerName(index, item)"
                                        @pointerdown.stop
                                    />
                                    <div
                                        @click="editLayerName(index, item)"
                                        style="display: flex; align-items: center; cursor: pointer"
                                        v-if="layerEditState != index"
                                    >
                                        <iconSymbol style="margin-left: 8px" class="item-icon layers-edit" name="editLayer" v-if="!item.back" />
                                    </div>
                                </div>
                                <div class="layers-del" @click="delLayer(item, index)" v-if="!item.back && layers.length > 2">
                                    <iconSymbol class="item-icon" name="delLayer" />
                                </div>
                            </div>
                            <div class="layers-box">
                                <div class="layers-shapeCount">{{ $t("shapes") + item.count }}</div>
                                <div class="layers-item layers-move" v-if="isSelect && item.id != layerID" @click="moveLayers(index)">
                                    <iconSymbol
                                        v-show="item.visible"
                                        class="item-icon"
                                        name="moveToLayer"
                                        :content="$t('layerMove')"
                                        v-tippy="{ placement: 'bottom' }"
                                    />
                                </div>
                                <div class="layers-item" @click.stop="toggleShow(index, item.visible)">
                                    <iconSymbol
                                        v-show="item.visible"
                                        class="item-icon"
                                        name="showLayer"
                                        :content="$t('layerUnVisible')"
                                        v-tippy="{ placement: 'bottom' }"
                                    />
                                    <iconSymbol
                                        v-show="!item.visible"
                                        class="item-icon"
                                        name="unshowLayer"
                                        :content="$t('layerVisible')"
                                        v-tippy="{ placement: 'bottom' }"
                                    />
                                </div>
                                <div class="layers-item" @click.stop="toggleLock(index, item.lock)">
                                    <iconSymbol
                                        v-show="item.lock"
                                        class="item-icon"
                                        name="lockedLayer"
                                        :content="$t('layerUnLock')"
                                        v-tippy="{ placement: 'bottom' }"
                                    />
                                    <iconSymbol
                                        v-show="!item.lock"
                                        class="item-icon"
                                        name="unlockedLayer"
                                        :content="$t('layerLock')"
                                        v-tippy="{ placement: 'bottom' }"
                                    />
                                </div>
                                <div class="layers-item" @click.stop="activeThis($event, index)">
                                    <Radio v-model="item.active" :content="$t('layerActive')" v-tippy="{ placement: 'bottom-end' }"></Radio>
                                </div>
                                <div class="layers-item" @click.stop="togglePrint(index, item.print)">
                                    <iconSymbol
                                        v-show="item.print"
                                        class="item-icon"
                                        name="printLayer"
                                        :content="$t('layerUnPrint')"
                                        v-tippy="{ placement: 'bottom-end' }"
                                    />
                                    <iconSymbol
                                        v-show="!item.print"
                                        class="item-icon"
                                        name="unprintLayer"
                                        :content="$t('layerPrint')"
                                        v-tippy="{ placement: 'bottom-end' }"
                                    />
                                </div>
                            </div>
                        </div>
                    </vuedraggable>
                </div>
            </LockBoxForTitle>
        </transition>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import LockBoxForTitle from "./FloatTool/LockBoxForTitle.vue";
    import vuedraggable from "vuedraggable";

    @Component({
        components: {
            LockBoxForTitle,
            vuedraggable,
        },
    })
    export default class Layer extends Vue {
        show = false;
        lock = false;
        showMiniMap;

        get showBox() {
            return this.lock || this.show;
        }
        get dragTitle() {
            return this.$t("Layers.title");
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        set activeFunc(v) {
            this.$store.commit("setStatus", {
                type: "activeFunc",
                data: v,
            });
        }
        setActive() {
            console.log("show tool active");
            this.$store.commit("setFloatToolState", {
                activeFloat: "bpLayer",
            });
        }

        initPosition() {
            this.$nextTick(() => {
                if (this.$refs.floatDom) {
                    let dom = this.$refs.iconDom as HTMLElement,
                        boxDom = (this.$refs.floatDom as any).$el as HTMLElement,
                        rect = dom.getBoundingClientRect() as DOMRect,
                        boxrect = boxDom.getBoundingClientRect() as DOMRect;
                    let width = dom.offsetWidth,
                        height = dom.offsetHeight,
                        boxHeight = boxDom.offsetHeight,
                        left = rect.x,
                        top = rect.y,
                        gap = 4;
                    (this.$refs.floatDom as any).initPosition({ x: left, y: top - gap - boxHeight });
                }
            });
        }

        expandFunc() {
            this.show = !this.show;
            this.initPosition();
            this.setActive();
            this.activeFunc = "";
            this.sensors.track("LayerButton", {
                Catalogues: "BottomToolbar",
            });
        }
        close(e) {
            setTimeout(() => {
                let objTarget = this.$refs.layerbox as HTMLElement;
                let parentNode = e.target.parentNode;
                let miniMapIcon = document.querySelector("#mini-map-icon") as HTMLElement;
                while (parentNode !== miniMapIcon && parentNode) {
                    parentNode = parentNode.parentNode;
                }
                let closeMiniMap = parentNode === miniMapIcon && !this.showMiniMap; // 只有关闭迷你地图时不关闭，打开迷你地图时要关闭
                if (objTarget != e.target && !objTarget?.contains(e.target) && !closeMiniMap) {
                    this.show = false;
                }
            }, 110);
        }

        lockModal() {
            this.lock = true;
        }

        closeModal() {
            this.show = false;
            this.lock = false;
        }

        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        // layer
        layerRename = "";
        layerEditState = -1;

        updateLayerPosition() {
            if (this.lock) return;
            let handerEvent = () => {
                this.$bus.$off("scheduleEventDone");
                this.initPosition();
            };
            this.$bus.$on("scheduleEventDone", handerEvent);
        }

        newLayer() {
            this.$track("rightPanel", "layer", "new layer");
            let view = window["_view"];
            if (!view) return;
            view.createNewLayer();
            view.setPageStatus();
            this.updateLayerPosition();
        }
        delLayer(item, index) {
            if (item.count > 0) {
                this.$store.commit("setDialogState", {
                    type: "showDialog",
                    data: true,
                });
                this.$store.commit("setDialogState", {
                    type: "dialogType",
                    data: "delLayerTip",
                });
            } else {
                let view = window["_view"];
                if (!view) return;
                view.deleteLayer(index);
                view.setPageStatus();
                console.log();
                setTimeout(() => {
                    if (index > this.layers.length - 1) {
                        this.selectLayerIndex = this.layers.length - 1;
                    }
                }, 100);
            }
            this.updateLayerPosition();
        }
        editLayerName(index, item) {
            this.layerEditState = index;
            this.layerRename = item.name;
            setTimeout(() => {
                this.$refs["layer_" + index][0].focus();
            }, 0);
        }
        changeLayerName(index, item) {
            let view = window["_view"];
            if (this.layerRename.trim()) {
                this.layers[index].name = this.layerRename;
                view.layerNameChanged(index, this.layerRename);
                this.layerEditState = -1;
                view.setPageStatus();
            } else {
                this.layerRename = item._name;
                this.layerEditState = -1;
            }
        }
        activeThis(e, index) {
            console.log("active this");
            let view = window["_view"];
            this.$track("rightPanel", "layer", "active layer");
            view.layerActiveCheck(index);
            view.setPageStatus();
            this.selectLayerIndex = index;
        }
        toggleShow(index: number, visible: boolean) {
            this.$track("rightPanel", "layer", "toggle show layer");
            let view = window["_view"];
            if (!view) return;
            view.layerShowCheck(index, !visible);
            view.setPageStatus();
        }
        toggleLock(index: number, lock: boolean) {
            this.$track("rightPanel", "layer", "toggle lock layer");
            let view = window["_view"];
            if (!view) return;
            view.layerLockCheck(index, !lock);
            view.setPageStatus();
        }
        togglePrint(index: number, print: boolean) {
            this.$track("rightPanel", "layer", "toggle print layer");
            let view = window["_view"];
            if (!view) return;
            view.layerPrintCheck(index, !print);
            view.setPageStatus();
        }
        moveLayers(index) {
            let view = window["_view"];
            view.moveToLayer(index);
        }
        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }
        get activedLayer() {
            return this.layers.find((item) => {
                return item.active;
            }).name;
        }
        set activedLayer(e) {}
        get layerID() {
            return this.$store.state.shape.layerID;
        }
        get currentView() {
            return this.$store.state.ui.currentView;
        }
        get layers() {
            return this.$store.state.page.activedPageLayers;
        }
        set layers(data) {
            this.$store.commit("setPageStat", {
                type: "activedPageLayers",
                data,
            });
            window["_view"]._activePage.sortLayers(data);
        }
        get selectLayerIndex() {
            return this.$store.state.ui.selectLayerIndex;
        }
        set selectLayerIndex(v) {
            this.$store.commit("setStatus", {
                type: "selectLayerIndex",
                data: v,
            });
        }
        dragEnd(event) {
            if (this.selectLayerIndex == event.oldIndex) {
                this.selectLayerIndex = event.newIndex;
            }
        }
        @Watch("layerID")
        selectLayerByID(newv, oldv) {
            if (newv) {
                for (let i = 0; i < this.layers.length; i++) {
                    if (newv == this.layers[i].id && !this.layers[i].active) {
                        this.activeThis("", i);
                        break;
                    }
                }
            }
        }
        closeLayerContext() {
            this.$store.commit("closeContext");
        }
        showContext(e: MouseEvent, item, index) {
            this.$store.commit("setStatus", {
                type: "layerContextStatus",
                data: {
                    canMoveDown: index != this.layers.length - 2,
                    canMoveUp: index != 0,
                    isBackGround: item.back,
                    index,
                },
            });
            this.$store.commit("setStatus", {
                type: "contextPos",
                data: [e.pageX, e.pageY],
            });
            this.$store.commit("setStatus", {
                type: "activeContextType",
                data: this.$store.state.ui.contextType.layer,
            });

            this.$store.commit("setStatus", {
                type: "showContextMenu",
                data: true,
            });
        }
        activated() {
            this.$bus.$emit("setRightViewTitle", "layerSet");
        }
        get openFileLoading() {
            return this.$store.state.ui.openFileLoading;
        }

        created() {}
        mounted() {
            window.addEventListener("resize", this.initPosition);
            window.addEventListener("mousedown", this.close);
            this.$bus.$on("showMiniMap", (data) => {
                this.showMiniMap = data;
            });
        }
        beforeDestroy() {
            window.removeEventListener("resize", this.initPosition);
            window.removeEventListener("mousedown", this.close);
        }
    }
</script>
<i18n>
{
  "zh": {
    "Layers": {
      "title": "图层",
      "newLayer": "新建图层"
    },
    "layerVisible": "显示图层",
    "layerUnVisible": "隐藏图层",
    "layerLock": "锁定图层",
    "layerUnLock": "解锁图层",
    "layerActive": "当前活动图层",
    "layerPrint": "打印包含此图层",
    "layerUnPrint": "打印不包含此图层",
    "shapes": "形状: ",
    "layerMove": "移动至此图层"
  },
  "en": {
    "Layers": {
      "title": "Layers",
      "newLayer": "New Layer"
    },
    "layerVisible": "Show Layer",
    "layerUnVisible": "Hide Layer",
    "layerLock": "Lock Layer",
    "layerUnLock": "Unlock Layer",
    "layerActive": "Active Layer",
    "layerPrint": "print contains this layer",
    "layerUnPrint": "print does not contains this layer",
    "shapes": "Shapes: ",
    "layerMove": "Move to this Layer"
  },
  "fr": {
    "Layers": {
      "title": "Calques",
      "newLayer": "Créer nouveau calque"
    },
    "layerVisible": "Afficher le calque",
    "layerUnVisible": "Masquer le calque",
    "layerLock": "Verrouiller le calque",
    "layerUnLock": "Déverrouillez le calque",
    "layerActive": "Calque active",
    "layerPrint": "L'impression contient ce calque",
    "layerUnPrint": "L'impression n'inclut pas ce calque",
    "shapes": "formes:",
    "layerMove": "Déplacer vers ce calque"
  },
  "de": {
    "Layers": {
      "title": "Ebenen",
      "newLayer": "Neue Ebene"
    },
    "layerVisible": "Ebene zeigen",
    "layerUnVisible": "Ebene verbergen",
    "layerLock": "Ebene schließen",
    "layerUnLock": "Ebene öffnen",
    "layerActive": "Ebene aktivieren",
    "layerPrint": "Druck enthält diese Ebene",
    "layerUnPrint": "Druck enthält diese Ebene nicht",
    "shapes": "Formen ",
    "layerMove": "Nach dieser Ebene verziehen"
  },
  "jp": {
    "Layers": {
      "title": "レイヤー",
      "newLayer": "レイヤーを新規作成"
    },
    "layerVisible": "レイヤーを表示",
    "layerUnVisible": "レイヤーを非表示",
    "layerLock": "レイヤーをロック",
    "layerUnLock": "レイヤーのロックを解除",
    "layerActive": "現在のレイヤー",
    "layerPrint": "印刷する時、このレイヤーを含む",
    "layerUnPrint": "印刷する時、このレイヤーを含めない",
    "shapes": "形状：",
    "layerMove": "このレイヤーに移動"
  },
  "es": {
    "Layers": {
      "title": "Capas",
      "newLayer": "Nueva capa"
    },
    "layerVisible": "Mostrar la capa",
    "layerUnVisible": "Ocultar la capa",
    "layerLock": "Bloquear la capa",
    "layerUnLock": "Desbloquear la capa",
    "layerActive": "Capa activa",
    "layerPrint": "La impresión contiene esta capa",
    "layerUnPrint": "la impresión no contiene esta capa",
    "shapes": "Formas",
    "layerMove": "Mover a esta capa"
  },
  "pt": {
    "Layers": {
      "title": "Camadas",
      "newLayer": "Nova Camada"
    },
    "layerVisible": "Mostrar Camada",
    "layerUnVisible": "Esconder Camada",
    "layerLock": "Bloquear Camada",
    "layerUnLock": "Desbloquear Camada",
    "layerActive": "Ativar Camada",
    "layerPrint": "impressão contém esta camada",
    "layerUnPrint": "impressão não contém esta camada",
    "shapes": "Formas: ",
    "layerMove": "Mover para esta Camada"
  },
  "it": {
    "Layers": {
      "title": "Livelli",
      "newLayer": "Nuovo Livello"
    },
    "layerVisible": "Mostra Livello",
    "layerUnVisible": "Nascondi Livello",
    "layerLock": "Blocca Livello",
    "layerUnLock": "Sblocca Livello",
    "layerActive": "Livello Attivo",
    "layerPrint": "Il livello è compreso nella stampa.",
    "layerUnPrint": "Il livello non è compreso nella stampa.",
    "shapes": "Forme: ",
    "layerMove": "Sposta su Questo Livello"
  },
  "tw": {
    "Layers": {
      "title": "圖層",
      "newLayer": "新建圖層"
    },
    "layerVisible": "顯示圖層",
    "layerUnVisible": "隱藏圖層",
    "layerLock": "鎖定圖層",
    "layerUnLock": "解鎖圖層",
    "layerActive": "當前活動圖層",
    "layerPrint": "列印包含此圖層",
    "layerUnPrint": "列印不包含此圖層",
    "shapes": "形狀: ",
    "layerMove": "移動至此圖層"
  }
}
</i18n>
